import React, { useEffect, useState } from "react";

const ProgressBar = () => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setWidth(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div 
      style={{
        position: "fixed",
        top:0, // navbar height
        left: 0,
        height: "4px",
        width: `${width}%`,
        background: "#e4a282",
        zIndex: 9999,
        transition: "width 0.1s ease",
      }}
    />
  );
};

export default ProgressBar;
